import { AbstractRewardScoreExtended, IRewardScoreExtended } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class RewardScoreExtended extends AbstractRewardScoreExtended {
  private translateService: TranslateService;
  constructor(data: IRewardScoreExtended, translateService: TranslateService) {
    super(data);
    this.translateService = translateService;
  }
  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
}
